module.exports = __webpack_public_path__ + "static/media/icons.0c8d6369.svg";